import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

@Component({
  selector: 'cutting-order-remark-dialog',
  templateUrl: './order-remark-dialog.component.html',
  standalone: true,
  imports: [NgIf, MatFormFieldModule, MatDialogModule, MatInputModule, MatButtonModule, ReactiveFormsModule],
})
export class OrderRemarkDialogComponent implements OnInit {
  @Input() title = '';
  @Input() value = '';

  orderForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder, //
    public dialogRef: MatDialogRef<OrderRemarkDialogComponent>
  ) {}

  ngOnInit(): void {
    this.orderForm = this.formBuilder.group({
      note: [this.value],
    });
  }
}
